<template>
    <div>
        <h3 v-if="loggedIn">Welcome, {{ currentUser.first_name }}</h3>
    </div>
</template>

<script>
    export default {
        name: "Dashboard",
        computed: {
            currentUser() {
                return this.$store.getters.current_user
            },
            loggedIn() {
                return this.$store.getters.loggedIn;
            }
        },
    }
</script>

<style scoped>

</style>